<template lang="pug">
v-container(fluid class="tw-bg-white tw-shadow-md tw-content-center tw-h-16")
  v-row(align="center" class=" tw-pt-2")
    v-col(cols="auto")
      span(class="h4") {{ $t('Website.Common.sectionTitle') }}
    v-spacer
    v-col(cols="auto")
      v-btn(@click="themeDialog" text color="black" small class="tw-py-0 tw-my-0") {{ $t('Website.Common.theme') }}
    v-divider(vertical)
    v-col(cols="auto")
      v-btn(@click="pagesDialog" text color="black" small class="tw-py-0 tw-my-0") Pages
    v-divider(vertical)
    v-col(cols="auto")
      v-btn(@click="settingsDialog" text color="black" small class="tw-py-0 tw-my-0") {{ $t('Common.settings') }}
    v-spacer
  v-dialog(v-model="theme" width="80%")
    div(class="tw-bg-white website-settings-modal")
      kubiqa-website-options-theme-selection(:key=key @close="theme = false")
  v-dialog(v-model="pages" width="80%")
    div(class="tw-bg-white website-settings-modal")
      kubiqa-website-options-pages(:key=key @close="pages = false")
  v-dialog(v-model="settings" width="80%")
    div(class="tw-bg-white website-settings-modal")
      kubiqa-website-options-settings(:key=key @close="settings = false")
</template>

<script>
export default {
  data() {
    return {
      theme: false,
      pages: false,
      settings: false,
      key: 1,
    };
  },
  methods: {
    themeDialog() {
      this.key++;
      this.theme = true;
    },
    pagesDialog() {
      this.pages = true;
    },
    settingsDialog() {
      this.key++;
      this.settings = true;
    },
  },
};
</script>

<style lang="css">
.website-settings-modal {
  height: 80vh !important;
  max-height: 600px;
  width: 100%;
  position: relative;
}
</style>
